<template>
  <div>


    <cc-collapse :title="$t('ct-general-configs')">

        <div class="form-group">
            <label>{{ $t('ct-url-thank-you-page') }}</label>

            <div class="input-group mb-2">
                <div class="input-group-prepend">
                <div class="input-group-text">{{ $t('ct-mysite') }}.com/</div>
                </div>
                <input type="text" class="form-control" v-model="config.url" @keyup="save()" @change="save()" placeholder="url">
            </div>
        </div>

        <div class="form-group">
            <label for="">{{ $t('ct-show-ranking') }}</label>
            <div class="form-check">
                <input class="form-check-input" type="radio" v-model="config.show.ranking" :value="true">
                <label class="form-check-label" for="exampleRadios1">
                    {{ $t('ct-yes-show') }}
                </label>
            </div>
            <div class="form-check">
                <input class="form-check-input" type="radio"  v-model="config.show.ranking" :value="false">
                <label class="form-check-label" for="exampleRadios2">
                    {{ $t('ct-dont-show') }}
                </label>
            </div>
        </div>

        <div class="form-group">
            <label for="">{{ $t('ct-show-people-count') }}</label>
            <div class="form-check">
                <input class="form-check-input" type="radio" v-model="config.show.count" :value="true">
                <label class="form-check-label" for="exampleRadios1">
                    {{ $t('ct-yes-show') }}
                </label>
            </div>
            <div class="form-check">
                <input class="form-check-input" type="radio" v-model="config.show.count" :value="false">
                <label class="form-check-label" for="exampleRadios2">
                    {{ $t('ct-dont-show') }}
                </label>
            </div>
        </div>

    </cc-collapse>

    <cc-collapse :title="$t('ct-share-config')">
        <div class="form-group">
            <label for="">{{ $t('ct-theme') }}</label>
            <select class="form-control" v-model="config.show.share_theme" @change="save()">
                <option :value="'circle'">Circles</option>
                <option :value="'square'">Squares</option>
            </select>
        </div>
         <div class="form-group">
            <label for="">{{ $t('ct-align') }}</label>
            <select class="form-control" v-model="config.show.share_align" @change="save()">
                <option :value="'flex-start'">{{ $t('ct-left') }}</option>
                <option :value="'center'">{{ $t('ct-center') }}</option>
                <option :value="'flex-end'">{{ $t('ct-right') }}</option>
            </select>
        </div>
        <div class="form-group">
            <label for=""> {{ $t('ct-social-share') }}</label>
            <div class="form-check">
                <input class="form-check-input" type="checkbox" v-model="config.show.share_email" @change="save()">
                <label class="form-check-label" for="defaultCheck1">
                    Email
                </label>
            </div>
            <div class="form-check">
                <input class="form-check-input" type="checkbox" v-model="config.show.share_facebook" @change="save()">
                <label class="form-check-label" for="defaultCheck1">
                    Facebook
                </label>
            </div>
            <div class="form-check">
                <input class="form-check-input" type="checkbox" v-model="config.show.share_linkedin" @change="save()">
                <label class="form-check-label" for="defaultCheck1">
                    Linkedin
                </label>
            </div>
            <div class="form-check">
                <input class="form-check-input" type="checkbox" v-model="config.show.share_twitter" @change="save()">
                <label class="form-check-label" for="defaultCheck1">
                    Twiiter
                </label>
            </div>
            <div class="form-check">
                <input class="form-check-input" type="checkbox" v-model="config.show.share_whatsapp" @change="save()">
                <label class="form-check-label" for="defaultCheck1">
                    Whatsapp
                </label>
            </div>
            <div class="form-check">
                <input class="form-check-input" type="checkbox" v-model="config.show.share_telegram" @change="save()">
                <label class="form-check-label" for="defaultCheck1">
                    Telegram
                </label>
            </div>
        </div>
    </cc-collapse>

    <cc-collapse :title="$t('ct-button-config')">
            <cc-box-color ref="buttonBackground"></cc-box-color>
            <text-style-component ref="textButtonStyle"></text-style-component>

<!--             <cc-slider-component ref="buttonWidth"></cc-slider-component>-->
<!--             <cc-slider-component ref="buttonHeight"></cc-slider-component>-->
             <cc-slider-component ref="buttonRadius"></cc-slider-component>
             <cc-slider-component ref="buttonPadding"></cc-slider-component>
             <cc-slider-component ref="verticalPadding"></cc-slider-component>
             <cc-slider-component ref="horizontalPadding"></cc-slider-component>
    </cc-collapse>


    <cc-collapse :title="$t('ct-text-configs')">

        <text-style-component ref="titleRankingStyle"></text-style-component>
        <text-style-component ref="resultRankingStyle"></text-style-component>

        <cc-slider-component ref="paddingLeftResults"></cc-slider-component>
        <cc-slider-component ref="paddingTopResults"></cc-slider-component>
        <cc-slider-component ref="paddingBetweenResults"></cc-slider-component>

    </cc-collapse>

    <cc-collapse :title="$t('ct-input-configs')">

        <cc-slider-component ref="inputHeight"></cc-slider-component>
        <cc-slider-component ref="textareaHeight"></cc-slider-component>
        <text-style-component ref="inputStyle"></text-style-component>


    </cc-collapse>

    <cc-collapse  :title="$t('ct-layers')">
      <cc-z-index ref="z-index"></cc-z-index>
    </cc-collapse>

  </div>
</template>

<script>

import textStyleComponent from '../../../..//editor/resources/TextStyle.vue'

export default {
  name: 'LaunchAppOptions',
  components: { textStyleComponent },
  data() {
    return {
      config: {
          show: {}
      },
      callback: () => {}
    };
  },
  methods: {
    init(config, callback) {
        let vm = this;

        vm.config = _.clone(config);

        // this.$refs['buttonWidth'].setValues({defaultValue: vm.config.button.width, defaultValueChecked: true, min: 10, max: 500, canBeCheckbox: false, labelDesc: 'button-width', name: 'padding-left-texts', callback: vm.setButtonWidth});
        // this.$refs['buttonHeight'].setValues({defaultValue: vm.config.button.height, defaultValueChecked: true, min: 10, max: 500, canBeCheckbox: false, labelDesc: 'button-height', name: 'padding-left-texts', callback: vm.setButtonheight});
        this.$refs['buttonRadius'].setValues({defaultValue: vm.config.button.radius, defaultValueChecked: true, min: 0, max: 50, canBeCheckbox: false, labelDesc: 'radius', name: 'padding-left-texts', callback: vm.setButtonRadius});
        this.$refs['buttonPadding'].setValues({defaultValue: vm.config.button.paddingLeft, defaultValueChecked: true, min: 0, max: 50, canBeCheckbox: false, labelDesc: 'margin-left', name: 'padding-left-texts', callback: vm.setButtonPaddingLeft});

        this.$refs['verticalPadding'].setValues({defaultValue: vm.config.button.verticalPadding, defaultValueChecked: true, min: 0, max: 100, canBeCheckbox: false, labelDesc: 'vertical-padding', name: 'padding-left-texts', callback: vm.setverticalPaddingButton});
        this.$refs['horizontalPadding'].setValues({defaultValue: vm.config.button.horizontalPadding, defaultValueChecked: true, min: 0, max: 100, canBeCheckbox: false, labelDesc: 'padding', name: 'padding-left-texts', callback: vm.setHorizontalPaddingButton});

        this.$refs['buttonBackground'].setValues({defaultValue: vm.config.button.background, gradient: true, labelDesc: 'bg-color', name: 'backgroundColor', callback: vm.setButtonBackground});

        this.$refs['inputHeight'].setValues({defaultValue: vm.config.input.height, defaultValueChecked: true, min: 10, max: 300, canBeCheckbox: false, labelDesc: 'input-height', name: 'padding-left-texts', callback: vm.setInputHeight});
        this.$refs['textareaHeight'].setValues({defaultValue: vm.config.input.height, defaultValueChecked: true, min: 10, max: 300, canBeCheckbox: false, labelDesc: 'input-height', name: 'padding-left-texts', callback: vm.setTextareaHeight});

      // z-index
      this.$refs['z-index'].setValues({defaultValue: vm.config.zIndex, callback: vm.setZIndex});
        /**
         * converter objetos de texto
         */

        let obj = {
            name: 'textButtonStyle',
            defaultFamily: vm.config.button.family,
            defaultSize:  vm.config.button.size,
            defaultColor:  vm.config.button.color,
            shitOptions: false,
            showSizeMobile: false,
            defaultStroke:  vm.config.button.stroke,
            defaultAlign: vm.config.button.align,
            labelDesc: 'ct-blog-author-style',
            callback: vm.setButtonTextStyle
        }

        this.$refs['textButtonStyle'].setValues(obj, 'option-button');

        obj = {
            name: 'titleRankingStyle',
            defaultFamily: vm.config.texts.position_title.family,
            defaultSize:  vm.config.texts.position_title.size,
            defaultColor:  vm.config.texts.position_title.color,
            shitOptions: false,
            showSizeMobile: false,
            defaultStroke:  vm.config.texts.position_title.stroke,
            defaultAlign: vm.config.texts.position_title.align,
            labelDesc: 'ct-blog-author-style',
            callback: vm.setPositionStyle
        }

        this.$refs['titleRankingStyle'].setValues(obj, 'option');


        obj = {
            name: 'resultRankingStyle',
            defaultFamily: vm.config.texts.position_result.family,
            defaultSize:  vm.config.texts.position_result.size,
            defaultColor:  vm.config.texts.position_result.color,
            shitOptions: false,
            showSizeMobile: false,
            defaultStroke:  vm.config.texts.position_result.stroke,
            defaultAlign: vm.config.texts.position_result.align,
            labelDesc: 'ct-blog-author-style',
            callback: vm.setPositionResultStyle
        }

        this.$refs['resultRankingStyle'].setValues(obj, 'option');


        obj = {
            name: 'inputStyle',
            defaultFamily: vm.config.input.family,
            defaultSize:  vm.config.input.size,
            defaultColor:  vm.config.input.color,
            shitOptions: false,
            showSizeMobile: true,
            defaultStroke:  vm.config.input.stroke,
            defaultAlign: vm.config.input.align,
            defaultSizeMobile: vm.config.input.sizeMobile,
            labelDesc: 'ct-blog-author-style',
            callback: vm.setInputStyle
        }

        this.$refs['inputStyle'].setValues(obj, 'option-button');


        this.$refs['paddingLeftResults'].setValues({defaultValue: vm.config.texts.padding.left, defaultValueChecked: true, min: 10, max: 500, canBeCheckbox: false, labelDesc: 'padding', name: 'padding-left-texts', callback: vm.setPaddingLeft});
        this.$refs['paddingTopResults'].setValues({defaultValue: vm.config.texts.padding.top, defaultValueChecked: true, min: 10, max: 500, canBeCheckbox: false, labelDesc: 'vertical-padding', name: 'padding-top-texts', callback: vm.setPaddingTop});
        this.$refs['paddingBetweenResults'].setValues({defaultValue: vm.config.texts.padding.between, defaultValueChecked: true, min: 10, max: 500, canBeCheckbox: false, labelDesc: 'central-padding', name: 'padding-between-texts', callback: vm.setPaddingBetween});


        vm.callback = callback;
    },
    setHorizontalPaddingButton(value) {
        this.config.button.horizontalPadding = `${value}px`;
        this.save();
    },
    setverticalPaddingButton(value) {
        this.config.button.verticalPadding = `${value}px`;
        this.save();
    },
    setButtonPaddingLeft(value) {
        this.config.button.paddingLeft = `${value}px`;
        this.save()
    },
    setButtonWidth(value) {
        this.config.button.width = `${value}px`;
        this.save()
    },
    setButtonheight(value) {
        this.config.button.height = `${value}px`;
        this.save()
    },
    setZIndex(value) {
      this.config.zIndex = value;
      this.save();
    },
    setInputHeight(value) {
        this.config.input.height = `${value}px`;
        this.save()
    },
    setTextareaHeight() {
    },
    setButtonRadius(value) {
        this.config.button.radius = `${value}%`;
        this.save()
    },
    setButtonBackground(value) {
        this.config.button.background = value;
        this.save()
    },
    setButtonTextStyle(value) {
        let obj = _.clone(value);
        delete obj.element;
        delete obj.labeldesc;
        delete obj.listFont;
        delete obj.shitOptions;
        delete obj.showSizeMobile;
        delete obj.showSizeMobile;

        this.config.button = _.merge(obj);
        this.save();
    },
    setPositionStyle(value) {
        let obj = _.clone(value);
        delete obj.element;
        delete obj.labeldesc;
        delete obj.listFont;
        delete obj.shitOptions;
        delete obj.showSizeMobile;
        delete obj.showSizeMobile;


        this.config.texts.position_title = _.merge(obj);
        this.save();
    },
    setInputStyle(value){
        let obj = _.clone(value);
        delete obj.element;
        delete obj.labeldesc;
        delete obj.listFont;
        delete obj.shitOptions;
        delete obj.showSizeMobile;


        this.config.input = _.merge(obj);
        this.save();
    },
    setPositionResultStyle(value) {
        let obj = _.clone(value);
        delete obj.element;
        delete obj.labeldesc;
        delete obj.listFont;
        delete obj.shitOptions;
        delete obj.showSizeMobile;

        this.config.texts.position_result = _.merge(obj);
        this.save();
    },
    setPaddingLeft(value){
        this.config.texts.padding.left = `${value}px`;
        this.save();
    },
    setPaddingTop(value){
        this.config.texts.padding.top = `${value}px`;
        this.save();
    },
    setPaddingBetween(value){
        this.config.texts.padding.between = `${value}px`;
        this.save();
    },
    save() {
        this.callback(this.config);
    }
  },
  beforeDestroy() {
    this.config = {};
    this.callback = () => {};
  }
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/editor/apps/Forms/Launch/Options.vue